import PaginationTable, {ColumnType} from './pagination-table';

export default PaginationTable;

export type {ColumnType};
